import { Skeleton } from 'antd';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { CardTable, LOADING_BAR_STYLE } from './CardTable';
import styles from './CardTableSkeleton.module.scss';
import type { CardColumn } from './type';

const cx = classnames.bind(styles);

/** Placeholder generic — the loading branch renders neither columns nor rows. */
type SkeletonRow = { id: string };

// Module-level: stable identities, and no inline literals for `literals-in-props`.
const NO_COLUMNS: CardColumn<SkeletonRow>[] = [];
const NO_DATA: SkeletonRow[] = [];

export type Props = {
  testId?: string;
};

/**
 * `Suspense` fallback for the card layout of 支払明細 / 仕訳 (identical in both,
 * hence shared). A bar standing in for the `ControlArea` row, then the card —
 * delegated to `CardTable loading` so it can't drift from the real one.
 *
 * No section title: that stays real, rendered by `SectionHeading` outside the
 * boundary.
 */
export const CardTableSkeleton: FC<Props> = memo(({ testId }) => {
  return (
    <div className={cx('root')} data-testid={testId}>
      <Skeleton.Input active size='small' block style={LOADING_BAR_STYLE} />
      <CardTable<SkeletonRow> columns={NO_COLUMNS} data={NO_DATA} loading />
    </div>
  );
});
CardTableSkeleton.displayName = 'CardTableSkeleton';
